import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'unsaved-modal-dialog',
    templateUrl: 'unsaved-modal-dialog.component.html',
    standalone: false
})

export class UnsavedModalDialogComponent {

  public showCancelButton = false;
  public showDiscardButton = true;
  public isSaveable = true;

  constructor(public dialogRef: MatDialogRef<UnsavedModalDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.showCancelButton = data.showCancelButton;
      this.showDiscardButton = data.showDiscardButton;
      if (data.isSaveable != null) {
        this.isSaveable = data.isSaveable;
      }
    }
  }

  public closeDialog(state: UnsavedResultState = UnsavedResultState.Cancel) {
    this.dialogRef.close(state);
  }

  public saveChanges() {
    this.closeDialog(UnsavedResultState.Save);
  }

  public discardUnsavedChanges() {
    this.closeDialog(UnsavedResultState.Discard);
  }
}

export enum UnsavedResultState {
  Cancel = 0,
  Save = 1,
  Discard = 2,
}
